export default {
    indexIntegrationShifts:     { method: 'get',    url: 'integration_shifts' },
    storeIntegrationShift:      { method: 'post',   url: 'integration_shifts' },
    updateIntegrationShift:     { method: 'put',    url: 'integration_shifts/{id}'},
    destroyIntegrationShift:    { method: 'delete', url: 'integration_shifts/{id}'},
}